import React from 'react'
import { isExternalLink } from './helper'
import { LocalizedLink } from 'gatsby-theme-i18n'
import PropTypes from 'prop-types'

const Link = ({ children, className, href, onClick }) => {
  const externalLink = isExternalLink(href)

  return externalLink ? (
    <a
      className={className}
      href={href}
      onClick={onClick}
      target='_blank'
      rel='noopener noreferrer'
    >
      {children}
    </a>
  ) : (
    <LocalizedLink
      className={className}
      to={href}
      onClick={onClick}
    >
      {children}
    </LocalizedLink>
  )
}

export default Link

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func
}

Link.defaultProps = {
  className: '',
  href: '/',
  onClick: () => null
}
